'use strict';

export default class ShowController {

  /*@ngInject*/
  constructor($http, $stateParams) {
    this.$http = $http;
    this.$stateParams = $stateParams;
  }

  $onInit() {
    this.getApp(this.$stateParams.id);
  }

  getApp(id) {
    this.$http.get('/api/jdOrders/' + id).then(response => {
      this.jdOrder = response.data;
      console.log(this.jdOrder)
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/jdOrder/show/show.controller.js